import { Component,Inject, Optional } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationService } from '../../../services/service.index';
import { VerifyCompanyCodeModel } from '../../../../main/authentication/authentication.model';
import { GlobalCompanyService } from '../global-company.service';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MatCard } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FuseAlertComponent, FuseAlertService } from '@fuse/components/alert';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgxSpinnerService } from 'ngx-spinner';

export interface CompanyModel {
  userId: string;
  companyId: string;
  companyName: string;
  isSecurityCodeAvailable: boolean;
}

@Component({
  selector: 'app-company-securitycode',
  standalone: true,
  imports: [FuseAlertComponent,RouterOutlet, MatIconModule, MatCard, RouterModule, FormsModule, MatFormFieldModule, MatAutocompleteModule, MatTooltipModule,
    MatDatepickerModule, MatRadioModule, ReactiveFormsModule, CommonModule ,
    MatToolbarModule, MatInputModule, MatButtonModule, MatDialogModule,
  ],
  templateUrl: './company-securitycode.component.html',
  styleUrl: './company-securitycode.component.scss',
  providers: [GlobalCompanyService] 
})
export class CompanySecuritycodeComponent {
  companyCodeForm: FormGroup;
  isCompanySecurityCodeAvailable: boolean = false;
  isCompanyCodeVerify: boolean = false;
  companyCodeModel: VerifyCompanyCodeModel;
  apiResponseErrorMessage: string = null;

  private unsubscribeAll: Subject<any>;

  /**
   * 
   * @param formBuilder
   * @param matDialogRef
   * @param globalCompanyService
   * @param data
   */
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public fuseAlertService: FuseAlertService,
    public matDialogRef: MatDialogRef<CompanySecuritycodeComponent>,
    private globalCompanyService: GlobalCompanyService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: CompanyModel
  ) {
    this.isCompanySecurityCodeAvailable = data.isSecurityCodeAvailable;
    this.companyCodeModel = new VerifyCompanyCodeModel();
    data.companyName = data.companyName.replace(data.companyId + ". ", "");
    this.companyCodeModel.companyId = data.companyId;
    this.unsubscribeAll = new Subject();
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit(): void {
    this.companyCodeForm = this.formBuilder.group({
      companyId: [],
      code: ['', [Validators.required, ValidationService.noWhiteSpace, ValidationService.onlyNumberValidator, Validators.pattern("^[0-9]*$"), Validators.maxLength(4)]]
    });

  }

  /***
   * On Destroy
   */
  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }

  /** On submit of verify company Code form **/
  verifyCompanyCode(): void {
    if (this.isCompanySecurityCodeAvailable) {
      this.companyCodeModel.code = this.companyCodeForm.controls.code.value;
      if (this.companyCodeForm.dirty && this.companyCodeForm.valid) {
        this.spinner.show();
        this.globalCompanyService.verifyCompanyCode(this.companyCodeModel).subscribe(result => {
          this.afterCompanyResponse(result);
        });
      };
    } else {
      this.companyCodeModel.code = "0";
      this.spinner.show();
      this.globalCompanyService.verifyCompanyCode(this.companyCodeModel).subscribe(result => {
        this.afterCompanyResponse(result);
      });
    }
  }

  afterCompanyResponse(result) {
    if (result.status === 1) {
      this.spinner.hide();
      this.isCompanyCodeVerify = true;
      this.matDialogRef.close(['submit', this.isCompanyCodeVerify]);
    }
    else {
      this.spinner.hide();
      //this.apiResponseErrorMessage = result.message;
      this.fuseAlertService.show(result.message, result.status); 
    }
  }
}

